<template>
  <v-dialog
    v-model="dialog"
    :max-width="modalLayout.FORM_COMPACT"
    v-bind="modalPersistentOnlyViewport"
    @click:outside="close"
    @keydown.esc="close"
  >
    <v-card>
      <CrudFormDialogHeader
        :kicker="$t('user.accountInfo')"
        :title="$t('user.myAccount')"
      />

      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="2" class="custom-padding">
              <label>{{ $t('user.management.fields.userId') }}</label>
            </v-col>
            <v-col cols="10" class="custom-padding">
              <span>{{ userProfile?.userId }}</span>
            </v-col>
            <v-col cols="2" class="custom-padding">
              <label>{{ $t('user.management.fields.name') }}</label>
            </v-col>
            <v-col cols="10" class="custom-padding">
              <span>{{ userProfile?.name }}</span>
            </v-col>
            <v-col cols="2" class="custom-padding">
              <label>{{ $t('user.management.fields.company') }}</label>
            </v-col>
            <v-col cols="10" class="custom-padding">
              <span>{{ userProfile?.companyName }}</span>
            </v-col>
            <v-col cols="2" class="custom-padding">
              <label>{{ $t('user.management.fields.role') }}</label>
            </v-col>
            <v-col cols="10" class="custom-padding">
              <span>{{ getRoleLabel(userProfile?.userRole) }}</span>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn outlined class="solvit-crud-outline-btn" @click="close">
          {{ $t('common.close') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex';
import { USER_ROLE_LABEL_I18N_KEY } from '@/utils/userI18nKeys';
import CrudFormDialogHeader from '@/components/common/CrudFormDialogHeader.vue';
import { MODAL_MAX_WIDTH, MODAL_PERSISTENT_ONLY_VIEWPORT } from '@/constants/modalLayout';

export default {
  name: 'UserProfileDialog',
  components: {
    CrudFormDialogHeader
  },
  props: {
    dialog: {
      type: Boolean,
      required: true
    }
  },
  data: () => ({
    modalLayout: MODAL_MAX_WIDTH,
    modalPersistentOnlyViewport: MODAL_PERSISTENT_ONLY_VIEWPORT
  }),
  computed: {
    ...mapGetters({
      userProfile: 'user/getUserProfile'
    })
  },
  methods: {
    close() {
      this.$emit('update:dialog', false);
    },
    getRoleLabel(role) {
      const key = USER_ROLE_LABEL_I18N_KEY[role];
      return key ? this.$t(key) : role;
    }
  }
};
</script>

<style scoped>
.custom-padding {
  padding: 8px 12px !important;
}
</style>
